import React from 'react';

const Anchor = props => (
  <a {...props} />
);

export default Anchor;
